import React, { useEffect, useState } from "react";
import { Trash } from "phosphor-react";
import './cartcard.css';
import WishListIcon from "../WishlistIcon/WishListIcon";
import { useNavigate } from "react-router-dom";
import ProductQuantity from "../ProductQuantity/ProductQuanity";
import DeleteCartItemBtn from "../DeleteCartItemBtn/DeleteCartItemBtn";
import { useDispatch, useSelector } from "react-redux";
import { getColors } from "../../appState/slices/color/colorSlice";
const CartCard = ({ product, namefontsize, categoryfontsize }) => {
  const colors = useSelector((state) => state.color.colors);
  const [isHoveredAddToCart, setIsHoveredAddToCart] = useState(false);
  const [prodquanitty, setProductQuantity] = useState(product.quantity);
  const updateQuantity = ({ value }) => {
    setProductQuantity(value);
  }

  const dispatch = useDispatch();
  var defaultImageUrl;
  const navigate = useNavigate();
  if (product != undefined) {
    defaultImageUrl = product.product.defaultImageUrl;
  }
  const handleMouseEnter = (buttonname) => {
    if (buttonname === "addtocart") {
      setIsHoveredAddToCart(true);
    }
  };

  const handleMouseLeave = (buttonname) => {
    if (buttonname === "addtocart") {
      setIsHoveredAddToCart(false);
    }
  };

  useEffect(() => {
    dispatch(getColors());
  }, [])

  const colorCode =
    colors?.colors?.[product?.color]?.colorCode || "#ccc"; // default grey fallback

  return (
    <div className="cartcardcontainer">
      <div className="cartcardimageandheart" >
        <img
          className="cartcardimage"
          src={product.product.defaultImageUrl}
          alt="Product Image"
          onClick={() => navigate(`/${product.product.name}/${product.product._id}`)}
        />
        {/* <WishListIcon pagename="productlist" /> */}

        {/* <WishListIcon isWishlist={product.product?.isWishlist} id={product.product._id} pagename="productlist" /> */}
        <DeleteCartItemBtn styleclass={"deletebutton-cart"} cartid={product._id} productid={product.product._id} quantity={product.quantity} />
        <ProductQuantity quantity={product.quantity} diamondtype={product.diamondtype} purity={product.purity} quality={product.quality} productid={product.product._id} color={product.color} ringsize={product.ringsize}  />
      </div>
      <div className="cart-card-details">
        <div className="ellipsis">
          <div className="cartproduct-name t6 font-medium">
            {product.product.name}
          </div>
          <h5 className={`${namefontsize ? namefontsize : "t6"}`}>
            ₹ {product?.livePrice || product?.defaultPrice}
          </h5>

        </div>

        <div className="cartproduct-sizeandcolor t6 font-medium">
          <div className="cartproduct-size">
            {product.purity} | {product.diamondtype === "lab grown" ? "LGD" : "NATURAL"} | {product.quality}  {product.ringsize ? ` | ${product.ringsize} | ` : " | "}
          </div>
          <div className="cartproduct-color">
            <div className="colouredcircle" style={{ backgroundColor: colorCode }}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartCard;